import { action, makeAutoObservable, observable } from "mobx"

import notificationDeliveryService from "@services/notification/notificationDeliveryService"
import type {
  GetNotificationDeliveryInput,
  NotificationDeliveryDashboardDto,
} from "@services/notification/dto/notificationDeliveryDto"

/** Trạng thái rỗng cho dashboard trước khi có dữ liệu (tránh optional chaining khắp UI). */
const emptyDashboard = (): NotificationDeliveryDashboardDto => ({
  totalSent: 0,
  successRate: 0,
  failRate: 0,
  readRate: 0,
  avgRetryCount: 0,
  items: { items: [], totalCount: 0 },
})

/**
 * Store MobX cho dashboard Notification Delivery Tracking (task 12.2). Giữ metric tổng hợp
 * + danh sách delivery log đã phân trang do `GetDashboardMetrics` trả về trong một lần gọi,
 * sort CreationTime giảm dần từ API (R11.7). Gọi REST qua `notificationDeliveryService`.
 *
 * Tham chiếu: Requirements 11.5, 11.6, 11.7.
 */
class NotificationDeliveryStore {
  /** Metric tổng hợp + danh sách phân trang (một nguồn cho cả cards lẫn table). */
  @observable dashboard: NotificationDeliveryDashboardDto = emptyDashboard()
  @observable isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  /** Nạp metric + danh sách theo bộ lọc/phân trang hiện hành (R11.5/11.6/11.7). */
  @action
  async getDashboard(input: GetNotificationDeliveryInput) {
    this.isLoading = true
    try {
      this.dashboard = await notificationDeliveryService.getDashboardMetrics(input)
    } finally {
      this.isLoading = false
    }
  }
}

export default NotificationDeliveryStore
